var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table-cell",
    class: [_vm.customClass],
    style: ({
      width: _vm.widget.options.cellWidth + ' !important' || '',
      height: _vm.widget.options.cellHeight + ' !important' || '',
      'word-break': !!_vm.widget.options.wordBreak ? 'break-all' : 'normal'
    }),
    attrs: {
      "colspan": _vm.widget.options.colspan || 1,
      "rowspan": _vm.widget.options.rowspan || 1
    }
  }, [_vm._l((_vm.widget.widgetList), function(subWidget, swIdx) {
    return [('container' === subWidget.category) ? [_c(_vm.getComponentByContainer(subWidget), {
      key: swIdx,
      tag: "component",
      attrs: {
        "widget": subWidget,
        "parent-list": _vm.widget.widgetList,
        "index-of-parent-list": swIdx,
        "parent-widget": _vm.widget,
        "sub-form-row-id": _vm.subFormRowId,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex
      },
      scopedSlots: _vm._u([_vm._l((Object.keys(_vm.$scopedSlots)), function(slot) {
        return {
          key: slot,
          fn: function(scope) {
            return [_vm._t(slot, null, null, scope)]
          }
        }
      })], null, true)
    })] : [_c(subWidget.type + '-widget', {
      key: swIdx,
      tag: "component",
      attrs: {
        "field": subWidget,
        "parent-list": _vm.widget.widgetList,
        "index-of-parent-list": swIdx,
        "parent-widget": _vm.widget,
        "sub-form-row-id": _vm.subFormRowId,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex
      },
      scopedSlots: _vm._u([_vm._l((Object.keys(_vm.$scopedSlots)), function(slot) {
        return {
          key: slot,
          fn: function(scope) {
            return [_vm._t(slot, null, null, scope)]
          }
        }
      })], null, true)
    })]]
  })], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eef5ce8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-render/container-item/table-cell-item.vue
// module id = null
// module chunks = 